import singleUserRoutes from '@/router/routes/SingleUserRoutes'
import teamDeviceRoutes from '@/router/routes/TeamDeviceRoutes'
import multiUserRoutes from '@/router/routes/MultiUserRoutes'
import loginRegistrationRoutes from '@/router/routes/LoginRegistrationRoutes'
import { sharedRoutes, onboardingRoutes } from './SharedRoutes'

export const routes = [
  ...singleUserRoutes,
  ...multiUserRoutes,
  ...teamDeviceRoutes,
  ...sharedRoutes,
  ...loginRegistrationRoutes,
  ...onboardingRoutes,
]
